import React from "react";

function SearchIcon(props:any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19.003"
      viewBox="0 0 19 19.003"
    >
      <path 
        fill={props.color ? props.color: "#2f3336"}
        d="M18.742 16.43l-3.7-3.7a.89.89 0 00-.631-.26h-.6a7.716 7.716 0 10-1.336 1.336v.6a.89.89 0 00.26.631l3.7 3.7a.887.887 0 001.258 0l1.05-1.05a.9.9 0 00-.001-1.257zM7.719 12.47a4.75 4.75 0 114.75-4.75 4.748 4.748 0 01-4.75 4.75z"
        data-name="Icon awesome-search"
      ></path>
    </svg>
  );
}

export default SearchIcon;
